import { Component, Input } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { ProjectService } from '../../../../services/project.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DirectionService } from '../../../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-project-submission-result',
  standalone: true,
  imports: [DropdownModule, TagModule, InputTextareaModule, CommonModule, TableModule, FormsModule,
    TranslateModule
  ],
  templateUrl: './project-submission-result.component.html',
  styleUrl: './project-submission-result.component.scss'
})
export class PeriodicEvaluationComponent {
  dir!: 'rtl' | 'ltr';
  @Input() strategyId = 0
  @Input() projectId = 0
  no_rejections = 0
  no_submits = 0
  submissions = [] as any[];
  options!: { name: string, value: number }[];
  numberOfReject = 0;
  mainSubmission!: any;
  selectedSubmissionId = 0
  selectedSubmisson!: any;


  constructor(private projectService: ProjectService, private directionService: DirectionService) {
  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
    this.projectService.ListSubmission(this.strategyId, this.projectId).subscribe((response: any) => {
      let { no_rejections, no_submits } = response['data']['status']
      this.no_submits = no_submits;
      this.no_rejections = no_rejections;


      this.submissions = response['data']['submissions']

      this.options = this.submissions.map(x => {
        return { name: x.name, value: x.id }
      })

      this.numberOfReject = this.submissions.filter(x => {
        return x["status"] == "rejected"
      }).length

      this.mainSubmission = this.submissions.find(x => {
        return x.is_main
      })
      this.selectedSubmisson = this.mainSubmission;
      this.selectedSubmissionId = this.selectedSubmisson.id;



    })
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
  }
  versionChange() {
    this.selectedSubmisson = {
      ... this.submissions.find(x => {
        return x.id == this.selectedSubmissionId;
      })
    }

  }
}
